const NavigationTopBar = {
  mounted() {
    const id = this.el.getAttribute('data-navigation-section')
    const sectionText = this.el.querySelector(`#navigation-top-${id}-text`)
    const sectionMenu = this.el.querySelector(`#navigation-top-${id}-dropdown`)

    this.el.addEventListener('mouseover', () => {
      this.el.setAttribute('data-navigation-open', 'true')
      sectionText.setAttribute('aria-expanded', 'true')
      sectionMenu.setAttribute('aria-expanded', 'true')
    })

    this.el.addEventListener('mouseout', () => {
      this.el.setAttribute('data-navigation-open', 'false')
      sectionText.setAttribute('aria-expanded', 'false')
      sectionMenu.setAttribute('aria-expanded', 'false')
    })

    this.el.querySelector(`#navigation-top-${id}-dropdown-list`).addEventListener('focusout', (event) => {
      if (!this.el.contains(event.relatedTarget)) {
        this.el.setAttribute('data-navigation-open', 'false')
        sectionText.setAttribute('aria-expanded', 'false')
        sectionMenu.setAttribute('aria-expanded', 'false')
      }
    })

    sectionMenu.addEventListener('click', () => {
      this.el.setAttribute('data-navigation-open', this.toggle(this.el.getAttribute('data-navigation-open')))
      sectionText.setAttribute('aria-expanded', this.toggle(sectionText.getAttribute('aria-expanded')))
      sectionMenu.setAttribute('aria-expanded', this.toggle(sectionMenu.getAttribute('aria-expanded')))
    })
  },

  toggle(value) {
    return value === 'true' ? 'false' : 'true'
  },
}

export default NavigationTopBar
